import { AdapterContext } from '../adapters/adapter-context';
import { Named } from '../base/named';
import { ISaveResult } from '../../interfaces/ISaveStatus';

export enum Mutation {
    ADD,
    DELETE,
    UPDATE,
    RENAME,
    NOOP
}

export interface IMutationContext {
    adapterContext: AdapterContext;
}

export interface IMutation {
    mutation: Mutation;
    named: Named;
    /*
        All the resources to save for a named. The key === model.name
        is the payload for the named. Other resources can be stored alongside
        with the named
    */
    toResources?: (context: AdapterContext, named?: Named) => Promise<{[key: string]: {}}>;
    /*
        After saving the resources what action needs to be done
    */
    then?: () => void;
}

export interface IMutator {
    mutate: (mutations: IMutation[], context?: IMutationContext) => Promise<ISaveResult>;
}
